import { render } from "./SansView.vue?vue&type=template&id=40c43ca6&scoped=true"
import script from "./SansView.vue?vue&type=script&lang=js"
export * from "./SansView.vue?vue&type=script&lang=js"

import "./SansView.vue?vue&type=style&index=0&id=40c43ca6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c43ca6"]])

export default __exports__